(function () {
  if (window.AnywellAttribution && window.AnywellAttribution.version === "20260908") return;

  var STORAGE_KEY = "aw_attribution_v1";
  var COOKIE_DAYS = 30;
  var SYNC_TTL_MS = 10000;
  var UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_product",
    "utm_variant",
    "utm_phase",
    "utm_angle",
    "fbclid",
    "gclid",
    "gbraid",
    "wbraid",
    "srsltid"
  ];
  var CART_ATTRIBUTE_KEYS = [
    "first_landing_url",
    "first_landing_path",
    "first_landing_at",
    "first_referrer_url",
    "first_product_handle",
    "last_landing_url",
    "last_landing_path",
    "last_referrer_url",
    "first_ad_landing_url",
    "first_ad_landing_path",
    "first_ad_landing_at",
    "first_ad_referrer_url",
    "first_ad_product_handle",
    "last_ad_landing_url",
    "last_ad_landing_path",
    "last_ad_landing_at",
    "last_ad_referrer_url",
    "last_ad_product_handle",
    "last_product_handle",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_product",
    "utm_variant",
    "utm_phase",
    "utm_angle",
    "fbclid",
    "gclid",
    "gbraid",
    "wbraid",
    "srsltid",
    "first_utm_source",
    "first_utm_medium",
    "first_utm_campaign",
    "first_utm_content",
    "first_utm_term",
    "first_utm_product",
    "first_utm_variant",
    "first_utm_phase",
    "first_utm_angle",
    "first_fbclid",
    "first_gclid",
    "first_gbraid",
    "first_wbraid",
    "first_srsltid",
    "last_utm_source",
    "last_utm_medium",
    "last_utm_campaign",
    "last_utm_content",
    "last_utm_term",
    "last_utm_product",
    "last_utm_variant",
    "last_utm_phase",
    "last_utm_angle",
    "last_fbclid",
    "last_gclid",
    "last_gbraid",
    "last_wbraid",
    "last_srsltid"
  ];
  var consentApiReady = false;
  var consentActive = false;
  var guardsBound = false;
  var consentListenerBound = false;
  var syncInFlight = null;
  var syncInFlightHash = "";


  function nowIso() {
    return new Date().toISOString();
  }

  function safeString(value, maxLength) {
    return String(value || "").trim().slice(0, maxLength || 500);
  }

  function canonicalValue(value) {
    var text = String(value || "");
    for (var i = 0; i < 4; i += 1) {
      try {
        text = text.normalize("NFKC");
      } catch (error) {}
      var decoded = text;
      try {
        decoded = decodeURIComponent(text);
      } catch (error) {}
      if (decoded === text) break;
      text = decoded;
    }
    try {
      return text.normalize("NFKC");
    } catch (error) {
      return text;
    }
  }

  function hasMalformedEncoding(value) {
    var text = String(value || "");
    for (var i = 0; i < 4; i += 1) {
      if (text.indexOf("%") === -1) return false;
      try {
        var decoded = decodeURIComponent(text);
        if (decoded === text) return false;
        text = decoded;
      } catch (error) {
        return true;
      }
    }
    return false;
  }

  function containsPersonalData(value) {
    var text = canonicalValue(value);
    if (/[\u0000-\u001f\u007f]/.test(text)) return true;
    if (/\b[^\s@]+@[^\s@]+\.[^\s@]+\b/i.test(text)) return true;
    if (/\+?\d[\d\s().-]{6,}\d/.test(text)) return true;
    return /\b\d{1,6}\s+[a-z0-9.'-]+(?:\s+[a-z0-9.'-]+){0,4}\s+(?:street|st|road|rd|avenue|ave|lane|ln|drive|dr|boulevard|blvd|court|ct)\b/i.test(text);
  }

  function safeAttributionValue(value, maxLength) {
    if (hasMalformedEncoding(value) || containsPersonalData(value)) return "";
    return safeString(value, maxLength);
  }

  function safeUrl(value) {
    if (!value) return "";
    try {
      var url = new URL(value, window.location.href);
      if (
        !/^https?:$/.test(url.protocol) ||
        hasMalformedEncoding(url.pathname) ||
        containsPersonalData(url.pathname)
      ) return "";
      return safeString(url.origin + url.pathname, 700);
    } catch (error) {
      return "";
    }
  }

  function safePath(value) {
    if (!value) return "";
    try {
      var path = new URL(value, window.location.href).pathname;
      if (hasMalformedEncoding(path) || containsPersonalData(path)) return "";
      return safeString(path, 700);
    } catch (error) {
      return "";
    }
  }

  function sanitizeStore(data) {
    var sanitized = {};
    CART_ATTRIBUTE_KEYS.forEach(function (key) {
      if (!data || !data[key]) return;
      var value;
      if (key.indexOf("url") !== -1) value = safeUrl(data[key]);
      else if (key.indexOf("path") !== -1) value = safePath(data[key]);
      else value = safeAttributionValue(data[key], 300);
      if (value) sanitized[key] = value;
    });
    if (data && data._expires_at && Number.isFinite(Date.parse(data._expires_at))) {
      sanitized._expires_at = new Date(data._expires_at).toISOString();
    }
    return sanitized;
  }

  function readParams() {
    var params = {};
    try {
      var search = new URLSearchParams(window.location.search || "");
      UTM_KEYS.forEach(function (key) {
        var value = search.get(key);
        if (value) {
          params[key] = safeAttributionValue(
            value,
            /^(?:fbclid|gclid|gbraid|wbraid|srsltid)$/.test(key) ? 300 : 180
          );
        }
      });
    } catch (error) {}
    return params;
  }

  function hasAttributionParams(params) {
    return UTM_KEYS.some(function (key) {
      return Boolean(params[key]);
    });
  }

  function productHandleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    if (!match || hasMalformedEncoding(match[1])) return "";
    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return "";
    }
  }

  function inferUtmProduct(handle) {
    var value = String(handle || window.location.pathname || "").toLowerCase();
    if (/x-?024|x024/.test(value)) return "x024";
    if (/ys12|pgpw00004/.test(value)) return "ys12";
    if (/ys16|pgpw00006|wide-seat-power-wheelchair|150kg-capacity-electric-wheelchair/.test(value)) return "ys16max";
    return "";
  }

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY) || "";
      if (!raw) raw = decodeURIComponent(readCookie(STORAGE_KEY) || "");
      var data = JSON.parse(raw || "{}") || {};
      var expiresAt = Date.parse(data._expires_at || "");
      if (Number.isFinite(expiresAt) && expiresAt <= Date.now()) {
        clearStore();
        return {};
      }
      return data;
    } catch (error) {
      return {};
    }
  }

  function writeStore(data) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {}
    writeCookie(STORAGE_KEY, encodeURIComponent(JSON.stringify(data)), COOKIE_DAYS);
  }

  function readCookie(name) {
    try {
      var parts = String(document.cookie || "").split("; ");
      for (var i = 0; i < parts.length; i += 1) {
        var item = parts[i];
        if (item.indexOf(name + "=") === 0) return item.slice(name.length + 1);
      }
    } catch (error) {}
    return "";
  }

  function writeCookie(name, value, days) {
    try {
      var expires = new Date(Date.now() + days * 86400000).toUTCString();
      document.cookie = name + "=" + value + "; expires=" + expires + "; path=/; SameSite=Lax";
    } catch (error) {}
  }

  function clearStore() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
    try {
      window.sessionStorage.removeItem("aw_attr_cart_hash");
      window.sessionStorage.removeItem("aw_attr_cart_synced_at");
    } catch (error) {}
    try {
      document.cookie = STORAGE_KEY + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0; path=/; SameSite=Lax";
    } catch (error) {}
  }

  function hasConsent() {
    if (!consentApiReady) return false;
    try {
      return Boolean(
        window.Shopify &&
        Shopify.customerPrivacy &&
        Shopify.customerPrivacy.analyticsProcessingAllowed &&
        Shopify.customerPrivacy.marketingAllowed &&
        Shopify.customerPrivacy.analyticsProcessingAllowed() &&
        Shopify.customerPrivacy.marketingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function captureAttribution() {
    if (!hasConsent()) {
      clearStore();
      return {};
    }
    var data = sanitizeStore(readStore());
    var params = readParams();
    var productHandle = productHandleFromPath();
    var currentUrl = safeUrl(window.location.href);
    var currentPath = safePath(window.location.href);
    var referrer = safeUrl(document.referrer || "");
    var hasClick = hasAttributionParams(params);

    if (hasClick || !data._expires_at) {
      data._expires_at = new Date(Date.now() + COOKIE_DAYS * 86400000).toISOString();
    }

    if (!data.first_landing_url && currentUrl) {
      data.first_landing_url = currentUrl;
      if (currentPath) data.first_landing_path = currentPath;
      data.first_landing_at = nowIso();
    }
    if (referrer && !data.first_referrer_url) data.first_referrer_url = referrer;
    if (productHandle && !data.first_product_handle) data.first_product_handle = safeAttributionValue(productHandle, 160);

    if (currentUrl) data.last_landing_url = currentUrl;
    if (currentPath) data.last_landing_path = currentPath;
    if (referrer) data.last_referrer_url = referrer;
    if (productHandle) data.last_product_handle = safeAttributionValue(productHandle, 160);

    UTM_KEYS.forEach(function (key) {
      if (!params[key]) return;
      data[key] = params[key];
      if (!data["first_" + key]) data["first_" + key] = params[key];
      data["last_" + key] = params[key];
    });

    var inferred = inferUtmProduct(productHandle);
    if (inferred && !data.utm_product) data.utm_product = inferred;
    if (inferred && !data.first_utm_product) data.first_utm_product = inferred;
    if (inferred && hasClick && !data.last_utm_product) data.last_utm_product = inferred;

    if (hasClick && currentUrl) {
      if (!data.first_ad_landing_url) {
        data.first_ad_landing_url = currentUrl;
        if (currentPath) data.first_ad_landing_path = currentPath;
        data.first_ad_landing_at = nowIso();
        if (referrer) data.first_ad_referrer_url = referrer;
        if (productHandle) data.first_ad_product_handle = safeAttributionValue(productHandle, 160);
      }
      data.last_ad_landing_url = currentUrl;
      if (currentPath) data.last_ad_landing_path = currentPath;
      data.last_ad_landing_at = nowIso();
      if (referrer) data.last_ad_referrer_url = referrer;
      if (productHandle) data.last_ad_product_handle = safeAttributionValue(productHandle, 160);
    }

    writeStore(data);
    return data;
  }

  function cartAttributes(data) {
    var attrs = {};
    CART_ATTRIBUTE_KEYS.forEach(function (key) {
      if (!data[key]) return;
      var maxLength = key.indexOf("url") !== -1 || key.indexOf("path") !== -1 ? 700 : 300;
      var value = safeAttributionValue(data[key], maxLength);
      if (value) attrs[key] = value;
    });
    return attrs;
  }

  function hashObject(obj) {
    try {
      return JSON.stringify(obj);
    } catch (error) {
      return "";
    }
  }

  function shouldSync(attrs, force) {
    if (force) return true;
    var hash = hashObject(attrs);
    var previousHash = "";
    var previousAt = 0;
    try {
      previousHash = window.sessionStorage.getItem("aw_attr_cart_hash") || "";
      previousAt = Number(window.sessionStorage.getItem("aw_attr_cart_synced_at") || 0);
    } catch (error) {}
    return hash && (hash !== previousHash || Date.now() - previousAt > SYNC_TTL_MS);
  }

  function markSynced(attrs) {
    try {
      window.sessionStorage.setItem("aw_attr_cart_hash", hashObject(attrs));
      window.sessionStorage.setItem("aw_attr_cart_synced_at", String(Date.now()));
    } catch (error) {}
  }

  function syncCartAttributes(force) {
    if (!hasConsent()) {
      clearStore();
      return Promise.resolve(false);
    }
    var data = captureAttribution();
    var attrs = cartAttributes(data);
    var hash = hashObject(attrs);
    if (syncInFlight) return syncInFlight;
    if (window.AnywellCart && window.AnywellCart.busy) return Promise.resolve(false);
    if (!Object.keys(attrs).length || !shouldSync(attrs, force)) return Promise.resolve(false);
    if (!hasConsent()) return Promise.resolve(false);

    syncInFlightHash = hash;
    var syncController = new AbortController();
    var syncTimer = setTimeout(function () { syncController.abort(); }, 8000);
    syncInFlight = fetch((window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      keepalive: true,
      signal: syncController.signal,
      body: JSON.stringify({ attributes: attrs })
    }).then(function (response) {
      if (response.ok && hasConsent()) markSynced(attrs);
      return response.ok;
    }).catch(function () {
      return false;
    }).then(function (result) {
      clearTimeout(syncTimer);
      syncInFlight = null;
      syncInFlightHash = "";
      return result;
    });
    return syncInFlight;
  }

  // Attribution is best effort. It must never cancel a shopper action or redirect a cart link.
  function bindBackgroundSync() {
    if (guardsBound || !hasConsent()) return;
    guardsBound = true;
    document.addEventListener("cart:change", function () {
      var cart = window.AnywellCart;
      if (cart && cart.busy) cart.whenIdle().then(function (ok) { if (ok) syncCartAttributes(false); });
      else syncCartAttributes(false);
    });
    window.addEventListener("pagehide", function () { syncCartAttributes(false); });
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") syncCartAttributes(false);
    });
  }

  function applyConsentState() {
    if (!hasConsent()) {
      consentActive = false;
      clearStore();
      return;
    }
    if (consentActive) return;
    consentActive = true;
    captureAttribution();
    syncCartAttributes(false);
    bindBackgroundSync();
  }

  function loadConsentApi() {
    if (!consentListenerBound) {
      consentListenerBound = true;
      document.addEventListener("visitorConsentCollected", applyConsentState);
    }
    if (!window.Shopify || typeof Shopify.loadFeatures !== "function") {
      clearStore();
      return;
    }
    try {
      Shopify.loadFeatures([
        { name: "consent-tracking-api", version: "0.1" }
      ], function (error) {
        consentApiReady = !error;
        applyConsentState();
      });
    } catch (error) {
      consentApiReady = false;
      clearStore();
    }
  }

  window.AnywellAttribution = {
    version: "20260908",
    capture: captureAttribution,
    syncCartAttributes: syncCartAttributes
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadConsentApi);
  } else {
    loadConsentApi();
  }
})();
